import { getCurrentInstance } from 'vue';

/**
 * Composable to trigger a notification banner by emitting the
 * `setNotificationData` event on the global event emitter.
 */
export function useNotification() {
  const instance = getCurrentInstance();
  const proxy = instance?.proxy;
  const root = proxy?.$root;

  const eventEmitter = root?.$global_eventEmitter || proxy?.$global_eventEmitter;

  function openNotification(message: unknown): void {
    if (!eventEmitter) {
      console.warn('useNotification: $global_eventEmitter is not available');
      return;
    }
    eventEmitter.$emit('setNotificationData', message);
  }

  return { openNotification };
}
